var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 1133,
    viewBox: "0 0 1439 1133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_71_24",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1441,
    height: 1133
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0.255371V1133H1440V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_71_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.78 94.8655L432.885 106.336L965.703 579.957L978.598 568.487L445.78 94.8655Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.349 125.468L398.454 136.938L931.272 610.559L944.167 599.089L411.349 125.468Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.051 156.121L364.137 167.604L896.862 641.308L909.776 629.825L377.051 156.121Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.546 186.715L329.652 198.185L862.47 671.806L875.364 660.336L342.546 186.715Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.19 217.269L303.473 221.485L295.272 228.755L828.001 702.441L840.919 690.976L308.19 217.269Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.841 247.88L260.925 259.361L793.557 733.148L806.473 721.667L273.841 247.88Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.401 278.433L226.501 289.899L759.116 763.671L772.016 752.204L239.401 278.433Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.948 309.072L198.973 314.407L192.055 320.559L724.76 794.244L737.677 782.78L204.948 309.072Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.551 339.681L164.455 345.101L157.633 351.145L690.362 824.853L703.255 813.367L170.551 339.681Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.129 370.289L133.468 372.655L123.236 381.753L655.94 855.439L668.858 843.975L136.129 370.289Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.786 400.82L88.8695 412.302L621.484 886.073L634.401 874.592L101.786 400.82Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3265 431.479L54.4125 442.962L587.12 916.651L600.035 905.168L67.3265 431.479Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8872 462.092L21.3004 472.395L19.9941 473.557L552.699 947.243L565.616 935.778L32.8872 462.092Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.51045 492.679L-13.5327 503.369L-14.4277 504.165L518.277 977.851L531.194 966.365L-1.51045 492.679Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.9324 523.287L-47.9063 533.913L-48.8497 534.752L483.879 1008.46L496.772 996.973L-35.9324 523.287Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.457 1039.05L462.375 1027.58L-70.3543 553.874L-70.5478 554.067L-83.2474 565.36L449.457 1039.05Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.93 275.039L974.848 568.554L1304.93 862.07L1635.02 568.555L1304.93 275.039Z",
    fill: "url(#paint0_linear_71_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.03 338.347L789.129 568.565L1048.03 798.783L1306.93 568.565L1048.03 338.347ZM855.65 568.565L1048.03 397.499L1240.41 568.565L1048.03 739.631L855.65 568.565Z",
    fill: "url(#paint1_linear_71_24)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_24",
    x1: 1469.93,
    y1: 715.449,
    x2: 1178.42,
    y2: 387.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A9BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_24",
    x1: 1306.96,
    y1: 568.586,
    x2: 789.129,
    y2: 568.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AD5EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/frame-2.9ccb625b72cd9ba507eaa7debe8c068c.svg";
export { ForwardRef as ReactComponent };